<template>
  <StaffLayout section="Bulk Edit" showHeader>
    <div class="flex h-1/3">
      <div class="m-auto bg-blue-900 w-full text-white text-center text-4xl py-5">
        Feature Coming Soon!
      </div>
    </div>
  </StaffLayout>
</template>

<script setup lang="ts">
// import { useBldgStore } from "../../store/bldgStore";
// import { useUserStore } from "../../store/userStore";

// const bldgStore = useBldgStore();
// const userStore = useUserStore();

// const siteCode = bldgStore.bldgCode;
// var isPropertyLoading = computed(() => bldgStore.isLoading);
// var property = computed(() => bldgStore.property);

// let isUserLoading = computed(() => userStore.isUserLoading);

// let user = computed(() => userStore.user);
// let isLoggedIn = computed(() => userStore.isLoggedIn);
</script>
